import { createApiRef } from '@backstage/core-plugin-api';
import type { SpogReportV0Wire } from '@internal/plugin-spog-common';

export interface SpogApi {
  getReport(runId: string): Promise<SpogReportV0Wire>;
}

export const spogApiRef = createApiRef<SpogApi>({
  id: 'plugin.spog.service',
});
